"use client";

import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

const LoginPage = () => {
  const params = useSearchParams();
  const callbackUrl = params.get("callbackUrl");

  useEffect(() => {
    // Cognito is now the primary provider. If the user already has a Cognito
    // hosted-UI session (e.g. from signing into SH), this completes silently.
    signIn("cognito", {
      callbackUrl: callbackUrl ?? "/home",
      redirect: true,
    });
  }, [callbackUrl]);

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center space-y-2">
      <p className="text-slate-500">Authenticating...</p>
    </div>
  );
};

export default LoginPage;
